export const backspaceKeyCode = 8;
export const leftArrowKeyCode = 37;
export const rightArrowKeyCode = 39;
